// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('selectStockLocation', {
//         templateUrl: 'views/components/views/selectStockLocation/selectStockLocation.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'selectStockLocationService', 'logisticService', 'rememberService', function ($stateParams, stateService, utilityService, selectStockLocationService, logisticService, rememberService) {

//     		// #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let stockPlaceId = $stateParams.stockplace_id;

//             let variableNames = {
//                 stockzone_keyno: ''
//             };

//             vm.model = {
//                 stockZoneButtons: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('stockzone_keyno') }
//                 ],
//                 filterValueButtons: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filtervalue = '' }
//                 ],
//                 setting: {},
//     			selectListStockZones: [],
//                 itemsListStockLocations: []
//             };
    
//     		// #endregion VARIABLES & DEFINITIONS

//     		// #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadSetting() {
//                 vm.model.setting = (await selectStockLocationService.getSetting({ stockplace_id: stockPlaceId }))[0];
//             }

//             async function loadStockZones() {
//                 if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

//                 return vm.model.selectListStockZones = await selectStockLocationService.listStockZones({ stockplace_id: vm.model.setting.stockplace_id });
//             }
            
//             async function loadStockLocations() {
//                 if (utilityService.validateParmsValue(vm.model.setting.stockzone_keyno) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

//                 return vm.model.itemsListStockLocations = await logisticService.listStockLocation({
//                     stockzone_keyno: vm.model.setting.stockzone_keyno,
//                     stockplace_id: vm.model.setting.stockplace_id
//                 });
//             }
            
//     		// #endregion LOAD PROCEDURE FUNCTION CALLS
            
//             // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             function rememberFunc(id) {
//                 Object.keys(variableNames).forEach((key) => {
//                     switch (key) {
//                     	case 'stockzone_keyno':
//                             variableNames[key] = stateService.getCurrentName() + '.' + 'stockzone_keyno' + '/' + vm.model.setting.stockplace_id;
//                             break;
//                     	default:
//                     		variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                     		break;
//                     }
//                 });

//                 if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                 let variableValue = null;

//                 switch (id) {
//                     case 'stockzone_keyno':
//                         if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                         variableValue = vm.model.setting[id];
//                         break;
//                     default:
//                         break;
//                 }

//                 return rememberService.remember(variableNames[id], variableValue);
//             };

//             // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             // #region MULTI CLEAR FUNCTION

//             function clear(id) {
//                 switch (id) {
//                     case 'stockzone_keyno':
//                         vm.model.setting.stockzone_keyno = '0';

//                         if (vm.model.setting.stockzone_keyno === '0') {
//                             rememberFunc('stockzone_keyno');
//                             loadStockLocations();
//                         }
//                         break;
//                     default:
//                         break;
//                 }
//             }

//             // #endregion MULTI CLEAR FUNCTION

//     		// #region DIRECTION BUTTON FUNCTIONS
            
//             vm.selectedStocklocation = function (item) {
//                 let variableName = 'selected.stocklocation_keyno_' + vm.model.setting.stockplace_id;

//                 rememberService.remember(variableName, item.item_id).then(function () {
//                     stateService.back();
//                 });
//             }
            
//     		// #endregion DIRECTION BUTTON FUNCTIONS

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'stockzone_keyno':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.stockzone_keyno) !== true) return;

//                         vm.model.setting.stockzone_keyno = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.stockzone_keyno) !== true) return;

//                         rememberFunc('stockzone_keyno');
//                         loadStockLocations();
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadSetting();

//                 return Promise.all([
//                     loadStockZones()
//                 ]).then(() => {
//                     loadStockLocations();
//                     Promise.resolve();
//                 });
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
